import { Box, ListItemText, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { useAlertProviders } from "../hooks/query/useAlertProviders";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { mergeParams } from "../utils/url";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { MouseEventHandler } from "react";

export const AlertSchemaPicker: React.FC<{
  value: string;
  onChange: (v: string) => void;
  disabled?: boolean;
}> = ({value, onChange, disabled = false}) => {
  const {data: alertProviders = [] } = useAlertProviders();

  const {pathname} = useLocation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const onNew: MouseEventHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();
    navigate(`${pathname}?${mergeParams(searchParams, new URLSearchParams({dialog: "new-alert-schema"})).toString()}`);
  }

  const handleChange = (event: SelectChangeEvent<typeof value>) => {
    const v = event.target.value;
    if(v && v.length > 0) {
        onChange(v);
    }
  };


  return <Select
            size="small"
            value={value}
            onChange={handleChange}
            disabled={disabled}
            displayEmpty
        >
            <MenuItem key="new-alert" disabled={disabled}>
                <ListItemText onClick={onNew}>
                    <Box display="flex" gap={1} alignItems="center">
                    <FontAwesomeIcon icon={faPlus} />
                        New
                    </Box>
                </ListItemText>
            </MenuItem>

            {alertProviders?.map((ap) => (
                <MenuItem value={ap.id} key={ap.id}>
                    {ap.name}
                </MenuItem>
            ))}
        </Select>
}
